import { Alert, AlertTitle, Snackbar } from '@mui/material'
import React, { useEffect, useState } from 'react'

const ReusableSnackbar = ({ title, message, alertType = 'error' }) => {
  const [show, setShow] = useState(true)
  useEffect(() => {
    const timer = setTimeout(() => setShow(false), 5000)
    return () => clearTimeout(timer)
  }, [])

  return (
    <Snackbar
      sx={{ mt: 7 }}
      open={show}
      autoHideDuration={5000}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert variant="filled" severity={alertType} sx={{ width: '100%', textAlign: 'left' }}>
        <AlertTitle>{title}</AlertTitle>
        {message}
      </Alert>
    </Snackbar>
  )
}

export default ReusableSnackbar
